import React from 'react'
import Checkbox from '../../elements/Checkbox'
import FormatCurrency from '../../elements/FormatCurrency'

import { BEILAGE_OPTION_TYPE, COLOR_NAME } from '../../../constants'
import { useTranslation } from 'react-i18next';
import { clsx } from '../../../utils/helper';

const ToppingItem = ({
    item = {},
    checked,
    handleChangeTopping,
    type,
    setMoreInfo,
    addable
}) => {
    const { t } = useTranslation();

    const handleViewMoreInfo = e => {
        e.stopPropagation()
        e.preventDefault()

        setMoreInfo(item.productInfo);
    }

    return (
        <>
            <div
                onClick={() => addable && handleChangeTopping(item)}
                className={clsx('topping-item flex-between', !addable && 'disabled')}
            >
                <div className="topping-item--name">
                    <Checkbox
                        square={type === BEILAGE_OPTION_TYPE.MULTI}
                        checked={checked}
                    />
                    <span className="value">{item.name_food}</span>
                    {item.productInfo && (
                        <span
                            onClick={handleViewMoreInfo}
                            className="label-3 ml-2 primary-color"
                        >
                            {t('button.moreInfo')}
                        </span>
                    )}
                </div>
                {!!item.price && (
                    <div className="topping-item--price">
                        +<FormatCurrency amount={item.price} />
                    </div>
                )}
            </div>
        </>
    )
}

export default ToppingItem
